var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-im",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M-77.6 0H605v512H-77.6z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "translate(72.8) scale(.94)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ba0000",
    fillRule: "evenodd",
    d: "M629.4 512H-102V0h731.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffef00",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 2.2,
    d: "M281 376c.2-.6.6-6.8.4-6.8s-9.4-10.9-9.2-10.9c.2 0 11.8 2.6 11.8 2.2 0-.4 4.7-11.5 4.7-11.7l5.6 13.5 11.5 5-8 6.7 1.7 13c0 .3-8-7.6-8-7.6l-8.9 1s-1.2-4-1.6-4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 2.6,
    d: "M218.7 206.9c-7.7 4-37 37.5-41 42.7a77.3 77.3 0 0 1-16.8 23.4c-7.3 5.5-11.3 13-10.3 20 0 9 4.9 15 8.8 21.1 2.3 2.9 5.5 4.7 8.8 5 6.9.8 7.5 3 11 4.2 13.4 18.4 33.6 32 48 42.7a68.4 68.4 0 0 1 18 12.4c4.2 8.2 3.4 16 2.8 20L237.3 439c-1.9 11 7.8 8.6 8.3 6.4 4.3-5.7 10.8-1.7 20-34.3l12.8-17.1s4.9-2 4.9-2.5c7.5-9 1.8-14-2.5-15.7l-9.2-3.4s-10.8-10.8-11.3-10.8c-5.1-14.9-30.3-46.6-36.1-51-4-4.3-6-6-9.8-8.4-5.9-2.8-7.8-3.8-11.4-5.2-3-1.2-.9-4.5 1-6 20-10.9 35.7-22.9 54.8-35.1l3-2-6.9-39.2-31.8-11.2c-1.7 1.1-3 2.3-4.4 3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffec00",
    fillRule: "evenodd",
    d: "M245.3 413.1c0-.4 20-4 20-4l-2.5 7.4-19.7 6 2.2-9.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 2.2,
    d: "M193.6 338.5a37.9 37.9 0 0 1 21.6-20.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 2.4,
    d: "M244.6 413.3c1.3-.3 7-2 8.6-2.3 1.8-.4 3.5-.8 5.2-1.4 2-.4 3.2-.8 5.2-1.1a39 39 0 0 1 5-1.4M241 425.6a14.6 14.6 0 0 1 2.5-2c1.1-.4 5-2 6.5-2.3a54 54 0 0 0 4.7-1.4l4.6-1.2c1.5-.6 2.9-1 4.4-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 2.2,
    d: "M249 341.4h-.2c.8 0 .3 0-.9 1.4-.4 1.1-4 3.7-6.8 3.7a53 53 0 0 1-4.7.3l-1.3-.3m13.7 53.5h1.4c1.5 0 3 .3 4.2.3 1.5 0 2.9.4 4.3.4 1.5.2 3.2.1 4.7.4 1.6 0 3 .3 4.7.3 1.4.1 2.2.3 3.7.3l-3.7-.3c1.4.1 2.2.3 3.7.3m-32.7 33a13.6 13.6 0 0 1 2.3-2c1-.3 4.6-2 6-2.2a46.7 46.7 0 0 0 4.2-1.5l4.3-1c1.3-.7 2.6-1.1 4-1.5m5.8-41.2c-.8 2.3.3 2.9.7 3.9a12 12 0 0 0 5.7 3.4c1.2.3 2 .6 3.4 1.2.9 0 1.3.3 2 .5m-124.4-94.8h.3c-.9 0-.3.1 1.1-1 1-1.1 1.7-1.6 2.6-2.7m14.4 24c.2 0 16.6-8.2 18.3-10l3.7-2.9c1-.5 1.7-1.1 2.6-1.7.7-1 1.7-1.7 2.3-2.7 1-.9.5-1.8 1.4-2.9l1.3-3.8m20.8 12.2c.1.6-.2 2.4-.2 3.8 0 1.6-2.1 6.5-4.6 8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 2.2,
    d: "m192.6 307.8 6.7 2.1c5 1.8 15.4 8.4 16.5 9.3 1 .8 3 1.6 3.6 2.5 1.2 1 2 2.1 2.9 3.2 1 1.2 2 2.3 2.5 3.4a113.2 113.2 0 0 1 13.4 24.5c.7.7 1 1.7 1.7 2.8.6 1.4 1.3 2 2 3.1 1 .7 2.2 2 3.4 2.6 1.3 1.1 2.5 1.5 3.5 2.3 1.3.6 16.3 10 17 10.5 1.4 1.1 5.5 5.4 2.6 8.6-1.2 1-2.4 2.5-3.4 3-1.1 1.2-2.6 1.7-3.9 2.2-6.7 2-10.2 1.3-11.5 1.3h-1.4m-88.8-114.9c2 .8 1.2.2 2.9 1 1.2.5 2 .5 3 1 1.3.3 4.7 1 6.3 2.6 1.2 1 2 2 3.4 2.7a21.8 21.8 0 0 0 4.6 2.4c1.6.6 3.4 1.3 5 1.3h7.8-4 4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe606",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 2.2,
    d: "M159 293.3c4.2-.3 11.3 1 11.5 1l9.4-.2c5-.4 6-2.3 6.8-3.7 1.9-2.8 3.1-3.8 4.6-6 2.2-1.6 5.4 2.3 5.5 2.3 8 7.6 1.6 16.8 1.2 17.1-4 3.7-4.9 3.9-7.3 1.6-2.4-2.9-3.1-4.2-5.1-5.2-3.9-1.8-11.8-.4-12-.4l-4.1 1.6c-2 .7-3.2 2.4-6.5 3-3.5.2-4.6-.1-6.3-2.9-2.3-3.5-1.2-7.8 2.3-8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffef00",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 2.2,
    d: "M381.8 120.7c-.6 0-6.3 2.8-6.2 3 .1.1-4.8 13.5-4.9 13.4-.1-.2-3.5-11.7-3.9-11.5-.3.2-12.3 1.6-12.4 1.7l9-11.5-1.3-12.5 9.8 3.8 10.5-8c.2-.1-2.7 10.8-2.7 10.8l5.2 7.2s-3 3-3.1 3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 2.6,
    d: "M265 257.9c7.1 4.7 50.7 13.9 57.3 14.8a77 77 0 0 1 28.6 3.2c8.3 3.6 16.8 3.4 22.5-1 7.8-4.2 10.6-11.4 14-18a12 12 0 0 0 0-10c-2.6-6.4-1-8-1.6-11.6 9.4-20.8 11.4-45 13.6-62.9-.2-10.5.9-18.5 2-21.7a32 32 0 0 1 16-12.2l40.7-10.6c10.6-3.8 3.7-11 1.5-10.4-7-1-6.8-8.6-39.7-.7l-21.2-2.7s-4-3.3-4.5-3c-11.5-2.1-13.1 5.3-12.5 9.8l1.6 9.8s-4.1 14.6-3.9 15c-10.5 11.8-26 49.6-27 56.9-.5 6.8-3 5.5-2.4 12.2 0 5.2-.6 2 1.1 12.6.5 3.2-3.5 3-5.7 2-19.2-12-37.4-19.9-57.5-30.5l-3.1-1.6-30.8 25.2 5.8 33.2c1.8 1 3.4 1.5 5.1 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffec00",
    fillRule: "evenodd",
    d: "M431.7 133.6a375 375 0 0 1-13.3-15.4l7.6-1.5 14.8 14.3-9.1 2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 2.2,
    d: "M392 215.2a37.9 37.9 0 0 1-28.4-8.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 2.4,
    d: "M432.2 134.1c-1-.9-5.2-5-6.2-6.4a66.5 66.5 0 0 0-3.8-3.8c-1.3-1.5-2.3-2.4-3.6-4a37.1 37.1 0 0 1-3.6-3.6m29.6 15c-.3 0-2-.7-3-1.2-.8-.9-4.2-3.4-5.1-4.6a54.2 54.2 0 0 0-3.5-3.4c-1.2-1.3-2.1-2-3.3-3.5a30.3 30.3 0 0 1-3.4-3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 2.2,
    d: "m367.3 165.5.1.3c-.4-.8-.2-.3 1.7 0 1.2-.2 5.2 1.7 6.5 4.1.8 1.1 2 2.8 2.6 4 .2.3.2 1 .4 1.3m40-38.2-.2-.2-.6-1-1.8-3.9c-.7-1.2-1-2.7-1.7-3.9-.6-1.4-1.5-2.8-2-4.2-.8-1.5-1.2-2.8-2-4.4-.7-1.2-.8-2-1.6-3.3l1.6 3.3c-.7-1.2-.8-2-1.6-3.3m44.8 12.3a12 12 0 0 1-2.8-1c-.8-.7-4-3-5-4a47 47 0 0 0-3.3-3c-1-1.3-1.9-2-3-3.3a26.2 26.2 0 0 1-3.2-2.7m-38.9 15c2.5-.4 2.5-1.6 3.1-2.5.5-1 .9-3.5.2-6.6l-.6-3.5c-.4-.9-.4-1.4-.5-2m-21.7 154.8-.1-.2c.4.8.2.3-1.6-.5l-3.5-1m13.9-24.3c-.1-.2-15.3-10.4-17.7-11-1.4-.7-2.7-1-4.3-1.8l-2.8-1.4c-1.3-.2-2.4-.7-3.5-.7-1.2-.4-1.9.4-3.2.2l-4 .7m.5-24.1c.4-.4 2.2-1 3.4-1.7 1.4-.7 6.7-1.3 9.2.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 2.2,
    d: "m365.7 231.2-1.5-7a100 100 0 0 1 0-18.8c.2-1.3 0-3.4.5-4.5.3-1.4.8-2.7 1.3-4 .6-1.5 1.1-2.8 1.7-3.9.7-4 12-20.1 12.8-20.9a43 43 0 0 1 2-2.7c.3-1 1-1.8 1.6-3 1-1.1 1.2-2 1.8-3.2.1-1.1.6-2.9.6-4.2.3-1.7 0-3 .3-4.1-.2-1.5.7-19.2.8-20 .3-1.8 2-7.5 6.2-6.5 1.5.5 3.3.8 4.4 1.5 1.4.4 2.6 1.5 3.7 2.3 5 4.9 6.1 8.2 6.8 9.4l.7 1.2M352.6 276l-.1-.2c.4.7.2.3-.3-1.1-.1-1.3-.5-3-.7-4.2-.3-1.3-.9-2.7-.7-3.5-.5-1.3-.2-2.3 0-3.6.3-1.6.5-2.7.5-4.2.2-2 0-3.2.1-5-.5-1.5-.6-2.7-1.3-4.2l-2-4-2-3.5 2 3.4-2-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe606",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 2.2,
    d: "M369.5 267.6c-2.3-3.6-4.7-10.4-4.8-10.5l-4.7-8.2c-2.8-4-5-4-6.6-4-3.4-.3-4.9-1-7.4-1.1-2.6-1.2-.7-5.9-.8-6 2.7-10.6 14-9.6 14.4-9.4 5.1 1.7 5.7 2.4 4.9 5.6-1.3 3.5-2 4.8-2 7 .3 4.2 5.5 10.5 5.5 10.6l3.4 2.8c1.6 1.4 3.7 1.6 5.8 4.3 1.9 2.9 2.2 4 .6 6.8-2 3.8-6.2 4.9-8.3 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffef00",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 2.2,
    d: "M105.2 168.7c.5.4 5.8 3.7 6 3.5s14-3.4 13.8-3.2-7.8 9.3-7.4 9.5c.4.2 8 9.4 8.2 9.5l-14.5-1.2-9.8 7.8-2.2-10.2L87 180c-.2-.1 10.5-3.6 10.5-3.6l3.2-8.3s4.1.7 4.7.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 2.6,
    d: "M284 191.3c0-8.7-16.2-50.2-19-56.1a77.2 77.2 0 0 1-13-25.7c-1.5-9-6.3-16-13-18.4-7.9-4.1-15.5-2.5-22.8-1.8-3.6.7-6.7 2.7-8.4 5.5-4 5.7-6.1 5.2-8.9 7.7-22.5 3.5-43.8 15.1-60 23a68 68 0 0 1-19.3 10.2 32 32 0 0 1-19-6.6l-31.1-28.3c-9-6.7-11.2 3-9.5 4.5 3 6.4-3.5 10.3 21.2 33.6l9.3 19.2s-.5 5.2 0 5.4c4.4 10.8 11.6 8.1 15 5.1l7.3-6.7s14.5-4.6 14.7-5c15.6 2.3 55.8-5.3 62.4-8.5 6-3.3 6.3-.5 11.5-4.7 4.3-2.9 2-.6 10-7.9 2.4-2 4.3 1.3 4.8 3.7.4 22.7 3.8 42.2 5.9 64.8l.4 3.5 38 12 24.6-23-1-5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffec00",
    fillRule: "evenodd",
    d: "M88.7 119.8c.3.3-5.6 19.6-5.6 19.6l-5.4-5.5 3.8-20.3 7.2 6.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 2.2,
    d: "M178.8 108.4c7.2 8 9.5 21.2 8.2 28.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 2.4,
    d: "M89 119.1c-.3 1.3-1.5 7.2-2 8.7a66.8 66.8 0 0 0-1.2 5.3l-1.4 5.2c-.2 1.7-.5 3.3-1 5m-3.7-33c.1.3.5 2 .6 3.1-.2 1.2-.5 5.4-1 6.9a54.4 54.4 0 0 0-.9 4.8l-1 4.6a30.6 30.6 0 0 1-.8 4.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 2.2,
    d: "m150.7 156.3.1-.3c-.4.8 0 .3-.8-1.4-.9-1-1.4-5.3-.2-7.8a55 55 0 0 1 2-4.3c.1-.3.6-.7.8-1M98.8 129l-.1.2-.6 1c-.6 1.4-1.6 2.6-2.2 3.7-.6 1.3-1.7 2.3-2.3 3.6l-2.4 4c-.9 1.4-1.8 2.5-2.6 4l-2 3.2 2-3.2-2 3.2m-14.2-44.3c.2.2.7 1.9.8 3-.2 1-.4 5-.8 6.3l-.7 4.4c-.4 1.6-.5 2.7-1 4.3a26.2 26.2 0 0 1-.5 4.2M104 151c-1.7-1.9-2.7-1.2-3.8-1.3a12 12 0 0 0-5.7 3.5c-.8.9-1.5 1.6-2.6 2.5-.5.8-.9 1-1.4 1.5M232 90.4l-.1.3c.4-.8.1-.4.5 1.5.5 1.3.5 2.2 1 3.4m-27.9 1.8c0 .2-.3 18.5.5 20.9.2 1.5.6 2.7.8 4.6 0 1 .3 2 .4 3 .6 1.2.7 2.4 1.4 3.3.3 1.3 1.3 1.4 1.9 2.5.7.9 2 2.4 2.8 3m-20.5 12.9c-.6-.2-2-1.4-3.2-2-1.4-.8-4.9-4.9-5-7.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 2.2,
    d: "m206.5 121.6-5 5a94.3 94.3 0 0 1-15.8 10.3c-1.2.6-2.7 2-4 2.1-1.3.6-2.7.8-4 1.1a113.4 113.4 0 0 1-28.7 1.5 43.2 43.2 0 0 1-3.4-.2c-1 .2-2 .1-3.3.2-1.6-.1-2.4.2-3.7.3-1 .6-2.7 1.1-3.9 1.9-1.5.6-2.5 1.5-3.6 2-1 .9-16.4 9.8-17.2 10.2-1.6.7-7.3 2.5-8.8-1.6-.4-1.6-1-3.3-1.1-4.5-.5-1.4-.2-3-.2-4.4 1.4-6.9 3.6-9.6 4.2-10.8l.7-1.2M251 108l-.1.3c.3-.7.2-.4-.8.8-1 .8-2.2 2-3.1 3-1 .8-1.8 2-2.6 2.4-.8 1-1.8 1.4-3 2a20 20 0 0 0-3.8 1.9c-1.7.8-2.7 1.7-4.2 2.6-1 1.2-2 2-2.8 3.4-.8 1.3-1.6 2.4-2.3 3.9l-1.8 3.5 1.8-3.5-1.8 3.5m11.7 73.1.3-.5c-.5 1-.4.7.1-.9 0-1.8.5-4.1.5-5.8.3-1.8.6-3.7.6-5.5-.1-2-.1-4-.4-6 0-1.8-.3-3.7-.3-5.6 0-1.8-.2-3.3-.6-5a29.5 29.5 0 0 0-.4-4.8c.1-1.2-.2-2.4-.5-3.4l-1.2-5.1-1-4.1c-.2-1.6-1-3.6-1.4-4.9a13.6 13.6 0 0 1-1.1-3.4c-.5-1.1-1.2-2.4-1.3-3.6l-1.6-3.7-1.4-3.6c-.5-1.4-1.1-2.6-1.5-4-.5-.5-.6-1-.8-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe606",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 2.2,
    d: "M234.9 98.5a59 59 0 0 1-6.2 9.7l-4.2 8.4c-1.8 4.6-.7 6.5.1 7.8 1.7 3 2 4.6 3.2 6.8.5 2.8-4.5 3.8-4.5 3.9-10.4 3.6-15.7-6.4-15.7-6.9-1.4-5.2-1.2-6 2-7.1 3.6-.9 5-1 6.8-2.2 3.5-2.6 5.9-10.3 6-10.4l.4-4.4c.3-2-.6-4 .4-7.2 1.4-3.2 2.2-4 5.4-4.3 4.2-.3 7.5 2.6 6.3 5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffef00",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 2.2,
    d: "M221.3 199.7c-1.6-1.5 29.4 11.2 33.7 11.3 5.8-2.1 29.9-22.4 29.9-22.4.2 2 1.1 7.1 3.4 8.2-9.3 7.5-17.7 14.8-27 22.3.6 12-1.5 24.7 4.5 38 0 0-7.2.2-7.2 0-6.4-6.4-8.7-37.2-8.7-37.2l-30.6-13.6c1.5-1 2.6-3.9 2-6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 2.2,
    d: "M250.8 231.3c.5-.4-5.6 2.8-7.2 3.6-28.1 15-42.6 37-43.5 37.8l-2.2 3.4-2.3 3a60.6 60.6 0 0 1-3.6 4.7c-.2.6.4-.3.2.2m77.9-70.6a79 79 0 0 0 6.5 4.7c26.2 18.2 52.3 21.1 53.5 21.5 1 0 2.5.3 4 .5 1.2 0 2.6.4 3.8.5 1.4.2 4.4.8 5.8 1.2.6-.2-.5-.3 0-.4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIm);
export default __webpack_public_path__ + "static/media/im.ba78f5434b0a2732843aa29f81a00654.svg";
export { ForwardRef as ReactComponent };